<template>
   <div class="field">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteField()"/>
      <Delete :delete_message="delete_message" :show="show_remove_links" @close="$store.commit('show_remove_links',false)" @delete="unlinkFieldToTable()"/>

      <div v-if="table_type === 'events'">
         <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
            <template slot="title">
               <div class="title">{{FieldModel.forms.addField.title}}</div>
               <div class="subtitle">{{FieldModel.forms.addField.subtitle}}</div>
            </template>
            <template slot="content">
               <div>
                  <Form 
                     class_binding="row" 
                     :ref="FieldModel.forms.addField.name" 
                     :forms="FieldModel.forms.addField.forms" 
                     :form_data="FieldModel.forms.addField.data"
                  />
                  <div class="btns clearfix">
                     <div class="btn btn-primary btn-r" @click="addField({ref: $refs[FieldModel.forms.addField.name]})" :disabled="loading">
                        Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                     </div>
                  </div>
               </div>
            </template>
         </Modal>
      </div>
      <div v-if="table_type === 'playgrounds'">
         <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
            <template slot="title">
               <div class="title">{{FieldModel.forms.addFieldFaker.title}}</div>
               <div class="subtitle">{{FieldModel.forms.addFieldFaker.subtitle}}</div>
            </template>
            <template slot="content">
               <div>
                  <Form 
                     class_binding="row" 
                     :ref="FieldModel.forms.addFieldFaker.name" 
                     :forms="FieldModel.forms.addFieldFaker.forms" 
                     :form_data="FieldModel.forms.addFieldFaker.data"
                  />
                  <div class="btns clearfix">
                     <div class="btn btn-primary btn-r" @click="addFieldFaker({ref: $refs[FieldModel.forms.addFieldFaker.name]})" :disabled="loading">
                        Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                     </div>
                  </div>
               </div>
            </template>
         </Modal>
      </div>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{FieldModel.forms.editField.title}}</div>
            <div class="subtitle">{{FieldModel.forms.editField.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="FieldModel.forms.editField.name" 
                  :forms="FieldModel.forms.editField.forms" 
                  :form_data="FieldModel.forms.editField.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateField({ref: $refs[FieldModel.forms.editField.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_link_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_link_modal',false)">
         <template slot="title">
            <div class="title">{{FieldModel.forms.link_table.title}}</div>
            <div class="subtitle">{{FieldModel.forms.link_table.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="FieldModel.forms.link_table.name" 
                  :forms="FieldModel.forms.link_table.forms" 
                  :form_data="FieldModel.forms.link_table.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="linkFieldToTable({ref: $refs[FieldModel.forms.link_table.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix" v-if="has_add">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Field <i class="fa fa-plus"></i>
         </div>
      </div>

      <Table v-bind="FieldModel.tables.field.props" :data="fields" @on-action="handleActions">
         <template slot-scope="{ row }" slot="date">
            <strong class="tx-small">{{ moment(row.last_update).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="data_type">
            <span v-if="has_add"> - </span>
            <span v-else>{{row.data_type}}</span>
         </template>
         <template slot-scope="{ row }" slot="link">
            <strong class="tx-small" v-if="row.link">{{ row.link.table }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import field from "./field.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('field')
      Event.$off('select-field-changed')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('field',field,this.$store)
      
      Event.$on('select-field-changed',(payload) => {
         this.selectFieldChanged(payload)
      })
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         moment,
      };
   },
   computed: {
      ...mapGetters([
         'FieldModel',
         'fields',
         'table_type',
         'show_edit_modal',
         'show_create_modal',
         'show_delete_modal',
         'show_link_modal',
         'show_remove_links',
         'loading',
         'has_add',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'deleteField',
         'addField',
         'addFieldFaker',
         'selectFieldChanged',
         'linkFieldToTable',
         'unlinkFieldToTable',
         'updateField',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('field',field,this.$store)
      await this.fetchData(this.$route.params.table)
   }
}
</script>

<style lang="scss">
   .field{
      .tx-small{
         font-size: 12px;
      }
   }
</style>